import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import UnlockPage from "./pages/unlockPage/UnlockPage";
import ChatPage from "./pages/chatPage/ChatPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<UnlockPage />} />
        <Route path="/chat" element={<ChatPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
